import type { SelectOption } from '@aus-platform/design-system';
import type { DrillAndBlastFormType } from './types';


export const drillPatternOptions: SelectOption[] = [
  { label: 'Square', value: 'square' },
  { label: 'Staggered', value: 'staggered' },
  { label: 'Other', value: 'other' },
];

export const explosiveTypeOptions: SelectOption[] = [
  { label: 'ANFO', value: 'ANFO' },
  { label: 'SME', value: 'SME' },
  { label: 'Cartridge', value: 'cartridge' },
  { label: 'Other', value: 'other' },
];

export const drillAndBlastInitialState: DrillAndBlastFormType = {
  title: '',
  spacingMeters: null,
  burdenMeters: null,
  baseElevationMeters: null,
  expectedHoles: null,
  drillPattern: { label: 'Other', value: 'other' },
  explosiveType: { label: 'Other', value: 'other' },
  aoiWorkspaceLayer: null,
  extentWorkspaceLayer: null,
};
